// eslint-disable-next-line no-restricted-imports
import urlParser from '@daredrop/js-video-url-parser'
import includes from 'ramda/src/includes'
import { splitAndGetLast } from 'root/src/shared/util/ramdaPlus'

const twitchCollectionURL = 'twitch.tv/collections/'
const collectionUrlparser = (url) => {
	const id = splitAndGetLast('/', url)
	return {
		provider: 'twitch',
		mediaType: 'collection',
		id,
	}
}
const twitterUrl = 'twitter.com/'
const twitterUrlParser = url => ({
	provider: 'twitter',
	mediaType: 'text/html',
	id: url,
})

const youtubeClipUrl = 'youtube.com/clip/'
const youtubeShortsUrl = 'youtube.com/shorts/'

const youtubeClipParser = (url) => {
	const id = splitAndGetLast('/', url)
	return {
		provider: 'youtube',
		mediaType: 'clip',
		id,
	}
}

const youtubeShortsParser = (url) => {
	const id = splitAndGetLast('/', new URL(url).pathname)
	return {
		provider: 'youtube',
		mediaType: 'shorts',
		id,
	}
}

export default (videoUrl) => {
	if (videoUrl && includes(twitchCollectionURL, videoUrl)) return collectionUrlparser(videoUrl)
	if (videoUrl && includes(twitterUrl, videoUrl)) return twitterUrlParser(videoUrl)
	if (videoUrl && includes(youtubeClipUrl, videoUrl)) return youtubeClipParser(videoUrl)
	if (videoUrl && includes(youtubeShortsUrl, videoUrl)) return youtubeShortsParser(videoUrl)
	return urlParser.parse(videoUrl)
}
